(() => {
  const initialize = root => {
    root.querySelectorAll('.blanks-navigation header-drawer').forEach(drawer => {
      if (drawer.dataset.blanksNavigationReady) return;
      drawer.dataset.blanksNavigationReady = 'true';
      const details = drawer.querySelector('details');
      const summary = details?.querySelector('summary');
      const panel = drawer.querySelector('#menu-drawer');
      const close = drawer.querySelector('.blanks-nav__close');
      if (!details || !summary || !panel || !close) return;
      const dismiss = event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.closeMenuDrawer(event, summary);
      };
      drawer.addEventListener('click', event => {
        if (event.target.closest('[data-blanks-nav-close]')) dismiss(event);
      }, true);
      drawer.addEventListener('keyup', event => {
        if (event.key === 'Escape' && details.open) dismiss(event);
      }, true);
      panel.addEventListener('keydown', event => {
        if (event.key !== 'Tab' || !details.open) return;
        const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
          .filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && event.target === first) {
          event.preventDefault();
          event.stopPropagation();
          last?.focus();
        } else if (!event.shiftKey && event.target === last) {
          event.preventDefault();
          event.stopPropagation();
          first?.focus();
        }
      }, true);
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        setTimeout(() => {
          if (details.open) close.focus({ preventScroll: true });
        }, 80);
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
